import { inject } from '@angular/core';
import { GuardResult, Route, Router, UrlSegment } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { Role, User } from 'app/core/user/user.types';
import { Observable, of, switchMap, take } from 'rxjs';

export const RoleGuard = (roles: Role[]) => {
    return (route: Route, segments: UrlSegment[]): Observable<GuardResult> => {
        const usersService: UserService = inject(UserService);
        const authService: AuthService = inject(AuthService);
        const router = inject(Router);

        return authService.check().pipe(
            take(1),
            switchMap((status: boolean) => {
                if (!status) {
                    router.navigate(['/sign-in']);
                    return of(false);
                }

                return usersService.user$.pipe(
                    take(1),
                    switchMap((user: User | null) => {
                        if (!user) {
                            router.navigate(['/sign-in']);
                            return of(false);
                        }
                        return of(roles.includes(user.role));
                    })
                );
            })
        );
    };
};
